<template>
  <div style="width: 100%; height: 100%; background: #000">
    <div class="poster">
      <div class="text">
        <div class="left"></div>
        <div>{{ text }}</div>
        <div class="right"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      type: {
        heating: '缴纳取暖费',
        login: '登录',
        property: '缴纳物业费'
      },
      text: ''
    }
  },
  async mounted () {
    let id = this.$route.query.objectId
    // let id = 'qZT6074apw'
    // 获取活动详情
    let { data: rs } = await this.$tkParse.get(
      `https://cloud.runji.mokekeji.com/classes/couponActivity/${id}`
    )
    console.log(rs)
    // 获取所有优惠券并计算总金额
    let { data: coupons } = await this.$tkParse.get(
      `https://cloud.runji.mokekeji.com/classes/coupon`,
      {
        params: {
          where: {
            objectId: {
              $in: rs.details
            }
          }
        }
      }
    )
    let total = 0
    // 计算总金额
    for (let i in coupons.results) {
      let item = coupons.results[i]
      total += item.shopQuota * item.total
    }
    this.text = `${this.type[rs.type]}可获得${total}元代金券`
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.poster {
  width: 375px;
  height: 812px;
  background: url("./../../../assets/image/runji-poster.jpg");
  background-size: 100% 100%;
  position: relative;
}
.text {
  position: absolute;
  bottom: 140px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  .left {
    margin-right: 10px;
  }
  .right {
    margin-left: 10px;
  }
  .left,
  .right {
    width: 20px;
    height: 1px;
    background: #fff;
  }
}
</style>
